import React, { useEffect } from 'react'
import styled from '@emotion/styled'

const SupplementaryTermsElem = styled.div`
	grid-area: pageContent;
	background-color: var(--color-background);
	margin-bottom: 24px;
	padding: 32px;
`
const ExceptionList = styled.ul`
	list-style-type: disc;
	margin-left: 20px;
`

const LegalLinks = styled.a`
	color: var(--color-blue);
	text-decoration: underline;
`

const EmphasizedText = styled.em`
	font-style: italic;
`

const SupplementaryTerms = () => {

	// Note: This effect was added because this page doesn't
	// scroll to the top when navigated into. This issue only happens on this page.
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}, [])

	return (
		<SupplementaryTermsElem data-testid="supplementary-terms-page">
			<div className="text-32 text-latoBold mb-24">
				Website Terms of Use - Supplement for School Support Hub
			</div>
			<div className="text-16 text-regular mt-8">
				<div>
					Unless covered by one of the exceptions below, our <LegalLinks href='https://www.cambridge.org/legal/website-terms-of-use' target='_blank' rel='noopener'>Website Terms of Use</LegalLinks> {' '}
					and <LegalLinks href='https://www.cambridge.org/legal/privacy' target='_blank' rel='noopener'>Privacy Notice</LegalLinks> will apply to our School Support Hub.
				</div>
				<br />
				<div>
					If you access the School Support Hub on behalf of an organisation that has a contract with us (for example, because you are a teacher at a Cambridge International School) 
					or one of our Associates, you must also make sure that you comply with that contract at all times.
				</div>

				<br />
				<div>
					We reserve the right to update our terms and this supplement from time to time. 
					If we do, we will post those changes on this page or in some cases will let you know directly. 
					We will assume you are fine with these changes if you continue to use the School Support Hub 
					and <EmphasizedText className='text-bold'>Site</EmphasizedText>.
				</div>

				<br />
				<div className="mb-24">
					The terms in <EmphasizedText className='text-bold'>italics</EmphasizedText> in this supplement have the same meaning as in our Website Terms of Use. 
				</div>

				<div>
					<div className='text-24 text-latoBold mb-16'>Exceptions to our Website Terms of Use:</div>
					<ExceptionList>
						<li className='mb-16'>
							If you access the School Support Hub (a distinct part of the <EmphasizedText className='text-bold'>Site</EmphasizedText>) on behalf of an organisation that has a contract with us, 
							you may use the School Support Hub for commercial and educational purposes but only in accordance with your organisation's 
							agreement with us. 
						</li>
						<li className='mb-16'>
							We are not obliged to, but we reserve the right to, monitor and/or moderate <EmphasizedText className='text-bold'>User content pages</EmphasizedText> (or any other user generated content). 
						</li>
					</ExceptionList>
				</div>

				<br />
				<div className='mt-32'>We last updated these terms on June 2025</div>
			</div>
		</SupplementaryTermsElem>
	)
}
export default SupplementaryTerms
